<template>
  <div id="Dashboard"  class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="Quotes Chart" />
    
    <section id="summary_filters" style="display:flex; justify-content:center; margin-bottom:4rem">
      <div class="fields">
      <div class="field">
        <input id="switch_to_date" type="checkbox" name="switch_to_date" class="switch is-rounded is-info" checked="checked" v-model="to_date">
        <label for="switch_to_date" style="outline:none; margin-right:0.5rem; min-width">
          <span v-if="to_date">To date</span>
          <span v-else>All dates</span>
        </label>
      </div>
      <div class="select" style="margin-right:0.5rem">
        <select id="customer_select" v-model="filter_customer">
          <option value=''>All Customers</option>
          <option v-for="item in customer_items" :key="'cust_'+item" :value="item">{{item}}</option>
        </select>
      </div>
      
      <button id='filter_button' class="button is-info" type="button" @click="filter_summary_records">Filter</button>
      <div style="font-size:0.75em; margin-top:0.5rem">
        <span v-if="to_date">Previous period up to current day (ex. 7th day)</span>
        <span v-else>All days in previous period</span>
      </div>
      </div>
      
    </section>

    <section id="summary_table">
      
      <table class="table is-striped  is-fullwidth">
        <thead>
          <tr>
            <th></th>
            <th>Day</th>
            <th>MTD</th>
            <th>QTD</th>
            <th>YTD</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Quotes</th>
            <td>{{quote_total_today}}</td>
            <td>{{quote_total_month}}</td>
            <td>{{quote_total_quarter}}</td>
            <td>{{quote_total_year}}</td>
          </tr>
          <tr>
            <td>Previous</td>
            <td>{{quote_total_yesterday}}</td>
            <td>{{quote_total_month_last}}</td>
            <td>{{quote_total_quarter_last}}</td>
            <td>{{quote_total_year_last}}</td>
          </tr>
          <tr>
            <td>Percent</td>
            <td>{{diff_quotes_day}}</td>
            <td>{{diff_quotes_month}}</td>
            <td>{{diff_quotes_quarter}}</td>
            <td>{{diff_quotes_year}}</td>
          </tr>
          <tr>
            <th>Quote Profit</th>
            <td>{{q_profit_today}}</td>
            <td>{{q_profit_month}}</td>
            <td>{{q_profit_quarter}}</td>
            <td>{{q_profit_year}}</td>
          </tr>
          <tr>
            <th>Quote Margin</th>
            <td>{{q_margin_today}}</td>
            <td>{{q_margin_month}}</td>
            <td>{{q_margin_quarter}}</td>
            <td>{{q_margin_year}}</td>
          </tr>
          <tr>
            <th>Quote Capture Ratio</th>
            <td>{{quote_capture_today}}</td>
            <td>{{quote_capture_month}}</td>
            <td>{{quote_capture_quarter}}</td>
            <td>{{quote_capture_year}}</td>
          </tr>

          <tr>
            <th></th>
            <th>Day</th>
            <th>MTD</th>
            <th>QTD</th>
            <th>YTD</th>
          </tr>

          <tr>
            <th>Quote Number</th>
            <td>{{quote_num_today}}</td>
            <td>{{quote_num_month}}</td>
            <td>{{quote_num_quarter}}</td>
            <td>{{quote_num_year}}</td>
          </tr>
          <tr>
            <td>Previous</td>
            <td>{{quote_num_yesterday}}</td>
            <td>{{quote_num_month_last}}</td>
            <td>{{quote_num_quarter_last}}</td>
            <td>{{quote_num_year_last}}</td>
          </tr>
          <tr>
            <td>Percent</td>
            <td>{{diff_quote_num_day}}</td>
            <td>{{diff_quote_num_month}}</td>
            <td>{{diff_quote_num_quarter}}</td>
            <td>{{diff_quote_num_year}}</td>
          </tr>
          <tr>
            <th>Quote Lines</th>
            <td>{{quote_lines_today}}</td>
            <td>{{quote_lines_month}}</td>
            <td>{{quote_lines_quarter}}</td>
            <td>{{quote_lines_year}}</td>
          </tr>
          <tr>
            <td>Previous</td>
            <td>{{quote_lines_yesterday}}</td>
            <td>{{quote_lines_month_last}}</td>
            <td>{{quote_lines_quarter_last}}</td>
            <td>{{quote_lines_year_last}}</td>
          </tr>
          <tr>
            <td>Percent</td>
            <td>{{diff_quote_lines_day}}</td>
            <td>{{diff_quote_lines_month}}</td>
            <td>{{diff_quote_lines_quarter}}</td>
            <td>{{diff_quote_lines_year}}</td>
          </tr>

          <tr>
            <th></th>
            <th>Day</th>
            <th>MTD</th>
            <th>QTD</th>
            <th>YTD</th>
          </tr>

          <tr>
            <th>Sales</th>
            <td>{{sales_total_today}}</td>
            <td>{{sales_total_month}}</td>
            <td>{{sales_total_quarter}}</td>
            <td>{{sales_total_year}}</td>
          </tr>
          <tr>
            <td>Previous</td>
            <td>{{sales_total_yesterday}}</td>
            <td>{{sales_total_month_last}}</td>
            <td>{{sales_total_quarter_last}}</td>
            <td>{{sales_total_year_last}}</td>
          </tr>
          <tr>
            <td>Percent</td>
            <td>{{diff_sales_day}}</td>
            <td>{{diff_sales_month}}</td>
            <td>{{diff_sales_quarter}}</td>
            <td>{{diff_sales_year}}</td>
          </tr>
          <tr>
            <th>Profit</th>
            <td>{{profit_total_today}}</td>
            <td>{{profit_total_month}}</td>
            <td>{{profit_total_quarter}}</td>
            <td>{{profit_total_year}}</td>
          </tr>
          <tr>
            <td>Previous</td>
            <td>{{profit_total_yesterday}}</td>
            <td>{{profit_total_month_last}}</td>
            <td>{{profit_total_quarter_last}}</td>
            <td>{{profit_total_year_last}}</td>
          </tr>
          <tr>
            <td>Percent</td>
            <td>{{diff_profit_day}}</td>
            <td>{{diff_profit_month}}</td>
            <td>{{diff_profit_quarter}}</td>
            <td>{{diff_profit_year}}</td>
          </tr>
        </tbody>
      </table>
    </section>


    <div class="is-divider" data-content="OR"></div>
    <hr style="margin:5rem 5rem ;">

    <section id="chart_filters" style="display:flex; justify-content:center;">
      <div style="width:500px" >
        
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Group by</label>
          </div>
          <div class="field-body">
            <div class="field">
              <span class="select">
                    <select id="period" 
                        v-model="period" >
                      <option disabled hidden value="" style="color:grey;">Period</option>
                      <option value='day'>Day</option>
                      <option value='week'>Week</option>
                      <option value='month'>Month</option>
                      <option value='quarter'>Quarter</option>
                    </select>
                  </span>
            </div>
          </div>
        </div>
        
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Period</label>
          </div>
          <div class="field-body">
            <div class="field has-addons" >
              <p class="control">
                <span class="select">
                  <select id="date_range" 
                    v-model="date_range" @change="change_date(date_range)">
                    <option disabled hidden value="" style="color:grey;">Date Presets</option>
                    <option value='today'>Today</option>
                    <option value='week'>Week</option>
                    <option value='this_month'>This Month</option>
                    <option value='prev_month'>Prev Month</option>
                    <option value='this_quarter'>This Quarter</option>
                    <option value='prev_quarter'>Prev Quarter</option>
                    <option value='this_year'>This Year</option>
                    <option value='prev_year'>Prev Year</option>
                    <option value='all'>All</option>
                    <option disabled hidden value='custom'>Custom</option>
                  </select>
                </span>
              </p>
              <p class="control  is-expanded">
                <VueDatePicker v-model="range" :enable-time-picker="false" range/>
              </p>
            </div>
          </div>
        </div>
          
        <div class="buttons is-right">
          <button @click='reset' class="button is-small is-white">Reset</button>
          <button @click='ajax_get_chart_dashboard' class="button is-info">Filter</button>
        </div>
      </div>
    </section>

    <section id="plot_data_bar_line">
      <PlotlyFigure
        :plot_data="plotDataBarLine"
        :layout="layout_barline"
        :options="options"
        :key="figureKey_BarLine"
        >
      </PlotlyFigure>
    </section>

    <section id="plot_data_revenue">
      <PlotlyFigure
        :plot_data="plotDataRevenue"
        :layout="layout_revenue"
        :options="options"
        :key="figureKey_Revenue"
        >
      </PlotlyFigure>
    </section>

    <section id="plot_data_profit">
      <PlotlyFigure
        :plot_data="plotDataProfit"
        :layout="layout_profit"
        :options="options"
        :key="figureKey_Profit"
        >
      </PlotlyFigure>
    </section>

    <section id="dashboard_data" v-if="queryData.data.length>0">
      <DataTable2 
        
        :raw_data="queryData"
        :name="'dash_sales_detail'"
        :columns_from_parent="[
          {
            label: 'Part',
            field: 'part_number',
            type: 'text',
          },
          {
            label: 'Description',
            field: 'description',
            type: 'text',
          },
          {
            label: 'Invoice',
            field: 'invoice',
            type: 'text',
          },
          {
            label: 'Margin',
            field: 'margin',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0.00%')},
          },
          {
            label: 'Company PO',
            field: 'company_po_number',
            type: 'text',
          },
          {
            label: 'Profit',
            field: 'profit',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Unit Cost',
            field: 'unit_cost',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Unit Price',
            field: 'unit_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Total Cost',
            field: 'total_cost',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Total Price',
            field: 'total_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Bill Name',
            field: 'bill_name',
            type: 'text',
          },
          {
            label: 'Vendor',
            field: 'vendor_name',
            type: 'text',
          },
          {
            label: 'Dept Name',
            field: 'dept_name',
            type: 'text',
          },
          {
            label: 'Orig PO',
            field: 'original_po_number',
            type: 'text',
          },
          {
            label: 'Qty Invoiced',
            field: 'qty_invoiced',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
          },
          {
            label: 'Reference',
            field: 'reference',
            type: 'text',
          },
          {
            label: 'Invoice Date',
            field: 'invoice_date',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
          {
            label: 'Post Date',
            field: 'post_date',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
          {
            label: 'Time Created',
            field: 'time_created',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
        ]"
      />
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [queryData.data, 'SalesChartDashboard', null])">
          Download CSV
        </button>
      </div>
    </section>
  </div>
</template>

<style scoped>
 #row_labels_right>div, .column_label_bottom{
  color: slategray;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
  text-align:center;
}
#row_labels_left>div{
  color: #363636;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
  text-align:center;
}
.column_label_top{
  color: #363636;
  font-size: 1.7rem;
  font-weight: 600;
  line-height: 1.125;
  text-align:center;
}
#row_labels_right>div, #row_labels_left>div{
  transform:rotate(-90deg)
}
.card{
  margin: 1rem 0;
}
.total{
  font-size:2.5rem;
  text-align: center;
}
.percent_diff{
  display: flex;
  justify-content: center;
  align-items: center;
}
.small_num{
  color:slategray;
}
</style>


<script>
import DataTable2 from '@/components/shared/DataTable2.vue';
import PlotlyFigure from '@/components/shared/Plotly.vue';
import moment from 'moment';
import DataFrame from "dataframe-js";
var numeral = require('numeral');
import VueDatePicker from '@vuepic/vue-datepicker';
import { getDates } from '@/helpers/dates.js'
import {
  DASHBOARD_SALES,
  DASHBOARD_QUOTE_CHART,
  DASHBOARD_SALES_CHART_DETAIL
} from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';
import { useDropdownsStore } from '@/stores/dropdownsStore'

export default {
  name: 'DashboardQuotesChart',
  components: {
    DataTable2,
    PlotlyFigure,
    VueDatePicker,
    HeroContainer,
  },
  computed:{
    dropdownsStore(){
      return useDropdownsStore()
    },
    customer_items(){
      return this.dropdownsStore.customer
    },
    is_down_p_day: function(){
      return parseFloat(this.diff_profit_day)<0.0
    },
    is_down_p_month: function(){
      return parseFloat(this.diff_profit_month)<0.0
    },
    is_down_p_year: function(){
      return parseFloat(this.diff_profit_year)<0.0
    },
    
    is_down_q_day: function(){
      return parseFloat(this.diff_quotes_day)<0.0
    },
    is_down_q_month: function(){
      return parseFloat(this.diff_quotes_month)<0.0
    },
    is_down_q_year: function(){
      return parseFloat(this.diff_quotes_year)<0.0
    },

    is_down_q_num_day: function(){
      return parseFloat(this.diff_quote_num_day)<0.0
    },
    is_down_q_num_month: function(){
      return parseFloat(this.diff_quote_num_month)<0.0
    },
    is_down_q_num_year: function(){
      return parseFloat(this.diff_quote_num_year)<0.0
    },

    is_down_q_lines_day: function(){
      return parseFloat(this.diff_quote_lines_day)<0.0
    },
    is_down_q_lines_month: function(){
      return parseFloat(this.diff_quote_lines_month)<0.0
    },
    is_down_q_lines_year: function(){
      return parseFloat(this.diff_quote_lines_year)<0.0
    },

    is_down_s_day: function(){
      return parseFloat(this.diff_sales_day)<0.0
    },
    is_down_s_month: function(){
      return parseFloat(this.diff_sales_month)<0.0
    },
    is_down_s_year: function(){
      return parseFloat(this.diff_sales_year)<0.0
    },
    queryData(){
      let raw_query = [...this.queryDataRaw]
      if(Object.keys(raw_query).length == 0){
        return {site:'',data:[]}
      }
      return {site:'', data: raw_query,}
    },
    color_dict(){
      let colors = {}
      if (Object.prototype.hasOwnProperty.call(this.plotDataRaw, 'quotes')) {
        let quote_data = this.plotDataRaw.quotes
        let df = new DataFrame(quote_data)
        let groups = df.groupBy('customer')
        let agg_rows = groups.aggregate((group) => group.stat.sum('quotes')).rename('aggregation', 'quotes').sortBy('quotes', true).toCollection()
        for(let i in agg_rows){
          let mod = i % 10
          let customer = this.get_short_name(agg_rows[i].customer)
          colors[customer] = this.color_list[mod]
        }
      }
      return colors
    },
    plotDataProfit(){
      let data_dict = {}
      let data =  []
      if (Object.prototype.hasOwnProperty.call(this.plotDataRaw, 'quotes')) {
        let quote_data = this.plotDataRaw.quotes
        if (quote_data.length > 0){
          let df = new DataFrame(quote_data)
          let periods = df.unique('period').toDict().period
          periods.sort()
          let this_week = periods.slice(-1) // Get current week
          var data_this_week = { type: "pie", name:'This Week', values: [], labels: [],
                                textinfo: "label+value", xaxis:'x2', yaxis:'y2', textposition: 'inside',
                                hole:0.4, marker: {colors: []}, domain:{x:[0.8,1], y:[0,1]}
                              }
          for(let quote of quote_data){
            let customer = quote.customer
            customer = this.get_short_name(customer)
            if (Object.prototype.hasOwnProperty.call(data_dict, customer)) {
              data_dict[customer] = {type:'bar',  name:customer, legendgroup:customer, 
                                      marker: {color: this.color_dict[customer]}, x:[], y:[],
                                      hovertemplate: '%{y:$.4s}'
                                    }
            }
            if(quote.period == this_week){
              data_this_week.values.push(quote.profit)
              data_this_week.labels.push(customer)
              data_this_week.marker.colors.push(this.color_dict[customer])
            }

            // Revenue (quote price)
            data_dict[customer].x.push(quote.period)
            data_dict[customer].y.push(quote.profit)
          }
          for(let trace in data_dict){
            data.push(data_dict[trace])
          }
          data.push(data_this_week)
        }
      }
      return data
    },
    plotDataRevenue(){
      let data_dict = {}
      let data =  []
      if (Object.prototype.hasOwnProperty.call(this.plotDataRaw, 'quotes')) {
        let quote_data = this.plotDataRaw.quotes
        if (quote_data.length > 0){
          let df = new DataFrame(quote_data)
          let periods = df.unique('period').toDict().period
          periods.sort()
          // Get current week
          let this_week = periods.slice(-1) 
          var data_this_week = 
            { 
              type: "pie", 
              name:'This Week', 
              values: [], 
              labels: [],
              textinfo: "label+value", 
              xaxis:'x2', 
              yaxis:'y2',
              textposition: 'inside',
              hole:0.4, 
              marker: {
                colors: []
              }, 
              domain:{
                x:[0.8,1], 
                y:[0,1]
              },
          }
          for(let quote of quote_data){
            let customer = quote.customer
            customer = this.get_short_name(customer)
            if (!Object.prototype.hasOwnProperty.call(data_dict, customer)) {
              data_dict[customer] = {
                type:'bar',  
                name:customer, 
                legendgroup:customer, 
                marker: {color: this.color_dict[customer]}, x:[], y:[],
                                      hovertemplate: '%{y:$.4s}'
                                    }
            }
            if(quote.period == this_week){
              data_this_week.values.push(quote.quotes)
              data_this_week.labels.push(customer)
              data_this_week.marker.colors.push(this.color_dict[customer])
            }
            
            // Revenue (quote price)
            data_dict[customer].x.push(quote.period)
            data_dict[customer].y.push(quote.quotes)
          }
          for(let trace in data_dict){
            data.push(data_dict[trace])
          }
          data.push(data_this_week)
        }
      }
      return data
    },
    plotDataBarLine(){
      let data =  [ 
                    {type:'bar',  name:'Quotes', x:[], y:[], hovertemplate: '%{y:$.4s}',},
                    {type:'bar',  name:'Cost', x:[], y:[], hovertemplate: '%{y:$.4s}',},
                    {type:'bar',  name:'Profit', x:[], y:[], hovertemplate: '%{y:$.4s}',},
                    {type:'scatter', name:'Margin', yaxis: 'y2', x:[], y:[], line: {shape: 'spline'},},
                  ]
      if (Object.prototype.hasOwnProperty.call(this.plotDataRaw, 'quotes')) {
        let quote_data = this.plotDataRaw.quotes
        let df = new DataFrame(quote_data)
        let groups =  df.groupBy('period')
        let df_agg = groups.aggregate((group) => [group.stat.sum('quotes'), 
                                                  group.stat.sum('cost'), 
                                                  group.stat.sum('profit'),
                                                ])
        df_agg = df_agg.chain(
          row  => row.set('quotes', row.get('aggregation')[0]),
          row  => row.set('cost', row.get('aggregation')[1]),
          row  => row.set('profit', row.get('aggregation')[2]),
          row  => row.set('margin', row.get('profit')/row.get('quotes'))
        )
        
        let agg_data = df_agg.toCollection()
        for(let quote of agg_data){
            // Revenue (quote price)
            data[0].x.push(quote.period)
            data[0].y.push(quote.quotes)
            // Cost
            data[1].x.push(quote.period)
            data[1].y.push(quote.cost)
            // Profit
            data[2].x.push(quote.period)
            data[2].y.push(quote.profit)
            // Margin
            data[3].x.push(quote.period)
            data[3].y.push(quote.margin)
        }
      }
      return data
    },
    plotData(){
      let data = [{type:'scatter', name:'Quotes', x:[], y:[], line: {shape: 'spline'},}, 
                  {type:'scatter',  name:'POs', yaxis: 'y2', x:[], y:[], line: {shape: 'spline'},},
                  {type:'scatter',  name:'Invoices', yaxis: 'y2', x:[], y:[], line: {shape: 'spline'},}, 
                ]
      if (Object.prototype.hasOwnProperty.call(this.plotDataRaw, 'quotes')) {
        let quote_data = this.plotDataRaw.quotes
        let df = new DataFrame(quote_data)
        let groups =  df.groupBy('period')
        let df_agg = groups.aggregate((group) => [group.stat.sum('quotes'), group.stat.sum('cost'), group.stat.sum('profit'), group.stat.sum('num_quotes'), group.stat.sum('num_line_items'), group.stat.sum('margin')])
        df_agg = df_agg.chain(
          row  => row.set('quotes', row.get('aggregation')[0]),
          row  => row.set('cost', row.get('aggregation')[1]),
          row  => row.set('profit', row.get('aggregation')[2]),
          row  => row.set('num_quotes', row.get('aggregation')[3]),
          row  => row.set('num_line_items', row.get('aggregation')[4]),
          row  => row.set('margin', row.get('aggregation')[5])
        )
        
        let agg_data = df_agg.toCollection()
        for(let quote of agg_data){
            // quote
            data[0].x.push(quote.period)
            data[0].y.push(quote.quotes)
            // POs
            data[1].x.push(quote.period)
            data[1].y.push(quote.pos)
            // Invoices
            data[2].x.push(quote.period)
            data[2].y.push(quote.invoices)
        }
      }
      return data
    },
  },
  data: function(){
    return {
      // SUMMARY CARDS
      to_date: true,
      filter_customer: '',
      filter_user: '',
      dashboard_raw: {},
      q_profit_today: '$0.00',
      q_profit_month: '$0.00',
      q_profit_quarter: '$0.00',
      q_profit_year: '$0.00',
      q_margin_today: '$0.00',
      q_margin_month: '$0.00',
      q_margin_quarter: '$0.00',
      q_margin_year: '$0.00',
      quote_capture_today: '0%',
      quote_capture_month: '0%',
      quote_capture_quarter: '0%',
      quote_capture_year: '0%',
      profit_total_today: '$0.00',
      profit_total_yesterday: '$0.00',
      quote_total_today: '$0.00',
      quote_total_yesterday: '$0.00',
      quote_num_today: 0,
      quote_lines_today:0,
      quote_num_yesterday:0,
      quote_lines_yesterday:0,
      quote_num_month:0,
      quote_lines_month:0,
      quote_num_month_last:0,
      quote_lines_month_last:0,
      quote_num_quarter:0,
      quote_lines_quarter:0,
      quote_num_quarter_last:0,
      quote_lines_quarter_last:0,
      quote_num_year:0,
      quote_lines_year:0,
      quote_num_year_last:0,
      quote_lines_year_last:0,
      sales_total_today: '$0.00',
      sales_total_yesterday: '$0.00',
      profit_total_month: '$0.00',
      profit_total_month_last: '$0.00',
      profit_total_quarter: '$0.00',
      profit_total_quarter_last: '$0.00',
      quote_total_month: '$0.00',
      quote_total_month_last: '$0.00',
      quote_total_quarter: '$0.00',
      quote_total_quarter_last: '$0.00',
      sales_total_month: '$0.00',
      sales_total_month_last: '$0.00',
      sales_total_quarter: '$0.00',
      sales_total_quarter_last: '$0.00',
      profit_total_year: '$0.00',
      profit_total_year_last: '$0.00',
      quote_total_year: '$0.00',
      quote_total_year_last: '$0.00',
      sales_total_year: '$0.00',
      sales_total_year_last: '$0.00',
      diff_profit_day: '$0.00',
      diff_quotes_day: '$0.00',
      diff_quote_num_day:0,
      diff_quote_num_month:0,
      diff_quote_num_quarter:0,
      diff_quote_num_year:0,
      diff_quote_num_yesterday:0,
      diff_quote_num_month_last:0,
      diff_quote_num_quarter_last:0,
      diff_quote_num_year_last:0,
      diff_quote_lines_day:0,
      diff_quote_lines_month:0,
      diff_quote_lines_quarter:0,
      diff_quote_lines_year:0,
      diff_quote_lines_yesterday:0,
      diff_quote_lines_month_last:0,
      diff_quote_lines_quarter_last:0,
      diff_quote_lines_year_last:0,
      diff_sales_day: '$0.00',
      diff_profit_month: '$0.00',
      diff_quotes_month: '$0.00',
      diff_sales_month: '$0.00',
      diff_profit_quarter: '$0.00',
      diff_quotes_quarter: '$0.00',
      diff_sales_quarter: '$0.00',
      diff_profit_year: '$0.00',
      diff_quotes_year: '$0.00',
      diff_sales_year: '$0.00',
      // CHARTS
      figureKey_main: 0,
      figureKey_BarLine: 0,
      figureKey_Revenue: 0,
      figureKey_Profit: 0,
      figureKey_PO: 0,
      period: 'week',
      period_last_filtered: 'week',
      date_range: 'this_quarter',
      range: [
        moment().startOf('quarter').toDate(),
        moment().endOf('quarter').toDate()
      ],
      queryDataRaw: [],
      plotDataRaw: [],
      color_list:[
        '#1f77b4',  // muted blue
        '#ff7f0e',  // safety orange
        '#2ca02c',  // cooked asparagus green
        '#d62728',  // brick red
        '#9467bd',  // muted purple
        '#8c564b',  // chestnut brown
        '#e377c2',  // raspberry yogurt pink
        '#7f7f7f',  // middle gray
        '#bcbd22',  // curry yellow-green
        '#17becf'   // blue-teal
      ],
      layout_po: {
        yaxis: {
          title: {
                  text: 'POs',
                  font: {
                    size: 18,
                  }
                },
          rangemode: 'tozero',
          anchor: 'x1'
        },
        xaxis: {
          domain: [0, 0.78],
          ancor: 'y1'
        },
        yaxis2: {anchor: 'x2'},
        xaxis2: {domain: [0.8, 1], anchor: 'y2'},
        barmode: 'stack',
      },
      layout_profit: {
        yaxis: {
          title: {
                  text: 'Potential Profit',
                  font: {
                    size: 18,
                  }
                },
          rangemode: 'tozero',
          anchor: 'x1'
        },
        xaxis: {
          domain: [0, 0.78],
          ancor: 'y1'
        },
        yaxis2: {anchor: 'x2'},
        xaxis2: {domain: [0.8, 1], anchor: 'y2'},
        barmode: 'stack',
      },
      layout_revenue: {
        yaxis: {
          title: {
                  text: 'Potential Revenue',
                  font: {
                    size: 18,
                  }
                },
          rangemode: 'tozero',
          anchor: 'x1'
        },
        xaxis: {
          domain: [0, 0.78],
          ancor: 'y1'
        },
        yaxis2: {anchor: 'x2'},
        xaxis2: {domain: [0.8, 1], anchor: 'y2'},
        barmode: 'stack',
      },
      layout_barline: {
        legend: {
          x: 0,
          y: 1.3
        },
        yaxis: {
          title: {
            text: 'Potential Revenue',
            font: {
              size: 18,
              color: '#1f77b4'
            }
          },
          rangemode: 'tozero',
        },
        yaxis2: {
          title: {
                  text: 'Margin',
                  font: {
                    size: 18,
                    color: 'rgb(214, 39, 40)'
                  }
                },
          rangemode: 'tozero',
          tickformat: ',.0%',
          overlaying: 'y',
          side: 'right'
        },
        barmode: 'group', //'overlay'
      },
      layout: {
        legend: {
          x: 0,
          y: 1.3
        },
        yaxis: {
          title: {
            text: 'Quotes',
            font: {
              size: 18,
              color: '#1f77b4'
            }
          },
          rangemode: 'tozero',
          },
        yaxis2: {
          title: {
            text: 'POs and Invoices',
            font: {
              size: 18,
            }
          },
          rangemode: 'tozero',
          overlaying: 'y',
          side: 'right'
        },
      },
      options : {
        displayModeBar: false,
        responsive: true
      },
    };
  },
  mounted: function(){
    this.ajax_get_chart_dashboard()
    this.ajax_get_summary_dashboard(this.filter_customer, this.filter_user, this.to_date)
  },
  watch: {
    plotData:
      function(){
        // Change key to force the component to re-render
        // otherwise it will have height=0
        this.figureKey_main += 1
      },
    plotDataBarLine:
      function(){
        // Change key to force the component to re-render
        // otherwise it will have height=0
        this.figureKey_BarLine += 1
      },
    plotDataRevenue:
      function(){
        // Change key to force the component to re-render
        // otherwise it will have height=0
        this.figureKey_Revenue += 1
      },
    plotDataProfit:
      function(){
        // Change key to force the component to re-render
        // otherwise it will have height=0
        this.figureKey_Profit += 1
      },
  },
  methods: {
    getDates,
    get_short_name(name){
      if(name.length>12){
        name = name.slice(0,12)
      }
      return name
    },
    plot_click(click_data){
      // Get x value date from the first trace
      let date = click_data.points[0].x
      let period =  this.period_last_filtered

      let dt = moment.utc(date)
      let dt2 = moment.utc(dt).endOf(period)
      this.ajax_get_detail(dt.toISOString(), dt2.toISOString())
    },
    reset(){
      this.queryDataRaw = []
      this.plotDataRaw = [],
      this.period = 'week'
      this.period_last_filtered = 'week',
      this.date_range=  'this_quarter'
      this.range = [
        moment().startOf('quarter').toDate(),
        moment().endOf('quarter').toDate()
      ]
    },
    change_date(date_range){
      let range = this.getDates(date_range)
      if(range){
        this.range = range
      }
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    filter_chart_records(){
      this.ajax_get_chart_dashboard(this.filter_customer, this.filter_user)
    },
    filter_summary_records(){
      this.ajax_get_summary_dashboard(this.filter_customer, this.filter_user, this.to_date)
    },
    ajax_get_summary_dashboard(customer, user, to_date){
      let url = DASHBOARD_SALES
      this.set_searching(true)
      let this_vue = this
      function clean_dash(this_vue, dashboard){
        // Given a dashboard object, calculate deltas and format all numbers
        // Calculate differences
        dashboard['diff_quote_num_day'] = (dashboard['quote_num_today'] - dashboard['quote_num_yesterday'])/dashboard['quote_num_yesterday']
        dashboard['diff_quote_lines_day'] = (dashboard['quote_lines_today'] - dashboard['quote_lines_yesterday'])/dashboard['quote_lines_yesterday']
        dashboard['diff_profit_day'] = (dashboard['profit_total_today'] - dashboard['profit_total_yesterday'])/dashboard['profit_total_yesterday']
        dashboard['diff_q_profit_day'] = (dashboard['q_profit_total_today'] - dashboard['q_profit_total_yesterday'])/dashboard['q_profit_total_yesterday']
        dashboard['diff_quotes_day'] = (dashboard['quote_total_today'] - dashboard['quote_total_yesterday'])/dashboard['quote_total_yesterday']
        dashboard['diff_sales_day'] = (dashboard['sales_total_today'] - dashboard['sales_total_yesterday'])/dashboard['sales_total_yesterday']
        dashboard['diff_quote_num_month'] = (dashboard['quote_num_month'] - dashboard['quote_num_month_last'])/dashboard['quote_num_month_last']
        dashboard['diff_quote_lines_month'] = (dashboard['quote_lines_month'] - dashboard['quote_lines_month_last'])/dashboard['quote_lines_month_last']
        dashboard['diff_profit_month'] = (dashboard['profit_total_month'] - dashboard['profit_total_month_last'])/dashboard['profit_total_month_last']
        dashboard['diff_q_profit_month'] = (dashboard['q_profit_total_month'] - dashboard['q_profit_total_month_last'])/dashboard['q_profit_total_month_last']
        dashboard['diff_quotes_month'] = (dashboard['quote_total_month'] - dashboard['quote_total_month_last'])/dashboard['quote_total_month_last']
        dashboard['diff_sales_month'] = (dashboard['sales_total_month'] - dashboard['sales_total_month_last'])/dashboard['sales_total_month_last']
        dashboard['diff_quote_num_quarter'] = (dashboard['quote_num_quarter'] - dashboard['quote_num_quarter_last'])/dashboard['quote_num_quarter_last']
        dashboard['diff_quote_lines_quarter'] = (dashboard['quote_lines_quarter'] - dashboard['quote_lines_quarter_last'])/dashboard['quote_lines_quarter_last']
        dashboard['diff_profit_quarter'] = (dashboard['profit_total_quarter'] - dashboard['profit_total_quarter_last'])/dashboard['profit_total_quarter_last']
        dashboard['diff_q_profit_quarter'] = (dashboard['q_profit_total_quarter'] - dashboard['q_profit_total_quarter_last'])/dashboard['q_profit_total_quarter_last']
        dashboard['diff_quotes_quarter'] = (dashboard['quote_total_quarter'] - dashboard['quote_total_quarter_last'])/dashboard['quote_total_quarter_last']
        dashboard['diff_sales_quarter'] = (dashboard['sales_total_quarter'] - dashboard['sales_total_quarter_last'])/dashboard['sales_total_quarter_last']
        dashboard['diff_quote_num_year'] = (dashboard['quote_num_year'] - dashboard['quote_num_year_last'])/dashboard['quote_num_year_last']
        dashboard['diff_quote_lines_year'] = (dashboard['quote_lines_year'] - dashboard['quote_lines_year_last'])/dashboard['quote_lines_year_last']
        dashboard['diff_profit_year'] = (dashboard['profit_total_year'] - dashboard['profit_total_year_last'])/dashboard['profit_total_year_last']
        dashboard['diff_q_profit_year'] = (dashboard['q_profit_total_year'] - dashboard['q_profit_total_year_last'])/dashboard['q_profit_total_year_last']
        dashboard['diff_quotes_year'] = (dashboard['quote_total_year'] - dashboard['quote_total_year_last'])/dashboard['quote_total_year_last']
        dashboard['diff_sales_year'] = (dashboard['sales_total_year'] - dashboard['sales_total_year_last'])/dashboard['sales_total_year_last']
        dashboard['quote_capture_today'] = dashboard['sales_total_today']/dashboard['quote_total_today']
        dashboard['quote_capture_month'] = dashboard['sales_total_month']/dashboard['quote_total_month']
        dashboard['quote_capture_quarter'] = dashboard['sales_total_quarter']/dashboard['quote_total_quarter']
        dashboard['quote_capture_year'] = dashboard['sales_total_year']/dashboard['quote_total_year']
        
        // Format strings and save to vue instance
        for(let key in dashboard){
          if(key.startsWith('diff')){
            // Check for NaN
            if(Number.isNaN(dashboard[key]) | !Number.isFinite(dashboard[key])){
              dashboard[key] = 0
            }
            // Format all percentages
            dashboard[key] = numeral(dashboard[key]).format('0,0,0,0,0%')
          }else if(key.startsWith('q_margin')){
            // Format all percentages
            dashboard[key] = numeral(dashboard[key]).format('0,0,0,0,0.0%')
          }else if(key.startsWith('quote_capture')){
            // Format all percentages
            dashboard[key] = numeral(dashboard[key]).format('0,0,0,0,0%')
          }else{

            // Format all numbers
            if( key.includes('num') | key.includes('lines')){
              dashboard[key] = numeral(dashboard[key]).format('0,0,0,0,0')
            }else{
              dashboard[key] = numeral(dashboard[key]).format('$0,0,0,0,0')
            }           
          }
          
          // Save all numbers to Vue
          this_vue[key] = dashboard[key]
        }
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({local_datetime: moment().toISOString(true), customer: customer, user: user, to_date: to_date,}),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          this_vue.dashboard_raw = JSON.parse(JSON.stringify(res.dashboard))
          clean_dash(this_vue, res.dashboard)          
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajax_get_chart_dashboard(){
      this.queryDataRaw = []
      this.plotDataRaw = []
      this.period_last_filtered = this.period
      let url = DASHBOARD_QUOTE_CHART
      let begin_date = moment.utc(this.range[0]).format('YYYY-MM-DD')
      let end_date = moment.utc(this.range[1]).endOf('day').format('YYYY-MM-DD')
      this.set_searching(true)
      let this_vue = this
      function set_dash(this_vue, data){
        this_vue.plotDataRaw = data
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({begin_date: begin_date, end_date: end_date, period: this.period, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajax_get_detail(begin_date, end_date){
      this.queryDataRaw = []
      let url = DASHBOARD_SALES_CHART_DETAIL
      this.set_searching(true)
      let this_vue = this
      function set_detail(this_vue, data){
        this_vue.queryDataRaw = data.sales
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({begin_date: begin_date, end_date: end_date, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_detail(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
